import { ProgressBar } from "@adeccoux/tag-ds";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BaseContext } from "../../App";
import {
    CommonLoader,
    CommonPopup,
    CommonQuesProgress,
    QuesLoader,
    QuestionCommonPopup,
    SessionExpireCommonPopup,
    useScreenTransition,
    useTimer,
    redirectToAssessmentSummary,
    useTimerValues,
} from "../../util/common";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import {
    getNoCacheCall,
    postCall,
    getNumberOfQuestionAnswered,
} from "../../util/resources";
import SesHeader from "../header";
import WarmupComplete from "../instructions/warmupComplete";
import DisplayType2 from "./displayType2";
import DisplayType3 from "./displayType3";
import DisplayType4 from "./displayType4";

const TestTaker21 = () => {
    const [test, setTest] = useState();
    const [selectedAns, setSelectedAns] = useState(-1);
    const [selectedAns1, setSelectedAns1] = useState(-1);
    const [selectedAns2, setSelectedAns2] = useState(-1);
    const [selectedAns3, setSelectedAns3] = useState(-1);
    const [selectedAns4, setSelectedAns4] = useState(-1);
    const [nextDisable, setnextDisable] = useState(true);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const [sessionStatus, setSessionStatus] = useState(false);
    const [qpopupData, setQpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const { min, sec, totalSecLeft, startTimer, stopTimer } = useTimer();
    const { phase, loading, startTransition, done } = useScreenTransition();
    const location = useLocation();
    const { isWarmupDoneShown, setWarmupDoneShown } = useContext(BaseContext);

    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const qattempts = useRef(0);
    const correctExample = useRef(false);
    const formRef = useRef();
    const exampleTest = useRef();
    const quesNo = useRef(-1);
    const stepRef = useRef();
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });
    const assessmentTimerStarted = useRef(false);
    const { timerOverallAssessment } = useTimerValues();

    const buildMediaUrl = (file) => {
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };
    const [selectedC, setselectedC] = useState(true);

    const nextNavigate = async (prev = false) => {
        if (location.state.warmUp) {
            if (
                location.state.test.displayType === "4" ||
                location.state.test.displayType === "3"
            ) {
                await validateAnswMulti(
                    selectedAns1,
                    selectedAns2,
                    selectedAns3,
                    selectedAns4,
                    exampleTest.current[quesNo.current - 1]
                );
            } else {
                await validateAnsw(
                    selectedAns,
                    exampleTest.current[quesNo.current - 1]
                );
            }
        } else {
            startTransition(async () => {
                const elapsedTime = stopTimer();
                setselectedC((prev) => !prev);
                let quesObj = test.questions;
                if (
                    location.state.test.displayType === "4" ||
                    location.state.test.displayType === "3"
                ) {
                    const ansObj1 = {
                        answers: [],
                        structure: null,
                        value: selectedAns1,
                    };
                    const ansObj2 = {
                        answers: [],
                        structure: null,
                        value: selectedAns2,
                    };
                    const ansObj3 = {
                        answers: [],
                        structure: null,
                        value: selectedAns3,
                    };
                    const ansObj4 = {
                        answers: [],
                        structure: null,
                        value: selectedAns4,
                    };

                    quesObj[0].userAnswer = ansObj1;
                    quesObj[1].userAnswer = ansObj2;
                    quesObj[2].userAnswer = ansObj3;
                    quesObj[3].userAnswer = ansObj4;
                } else {
                    const ansObj = {
                        answers: [],
                        structure: null,
                        value: selectedAns,
                    };
                    let quesObj = test.questions;
                    quesObj[0].userAnswer = ansObj;
                }
                const otherData = {
                    duration:
                        location.state.test.timeByQuestion &&
                            location.state.test.bShowTimer
                            ? elapsedTime
                            : location.state.test.duration + elapsedTime,
                };
                if (
                    location.state.test.timeByQuestion &&
                    location.state.test.bShowTimer
                ) {
                    quesObj[0].duration = elapsedTime;
                }
                try {
                    let response;
                    if (test.lastPage) {
                        stopTimer();
                        response = await postCall(
                            TEST_COMPLETE + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                        redirectToAssessmentSummary(location, navigate);
                    } else {
                        response = await postCall(
                            TEST_QUESTIONS + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                    }
                    if (response.data.status === true) {
                        if (test.lastPage || prev === "timeEnded") {
                            redirectToAssessmentSummary(location, navigate);
                        } else {
                            setSelectedAns(-1);
                            setSelectedAns1(-1);
                            setSelectedAns2(-1);
                            setSelectedAns3(-1);
                            setSelectedAns4(-1);
                            formRef.current.reset();
                            quesNo.current += 1;
                            await getQuestion();
                        }
                    }
                    done();
                } catch (error) {
                    console.log(error);
                }
            }, true);
        }
    };

    const validateAnsw = async (selectedAns, question) => {
        let currectAns;
        let currectAnsVal;
        for (let i = 0; i < question.questions[0].answers.length; i++) {
            if (question.questions[0].answers[i].score == 1) {
                currectAns = i;
                currectAnsVal = question.questions[0].answers[i].content;
            }
        }
        if (correctExample.current) {
            startTransition(async () => {
                correctExample.current = false;
                if (test.lastPage) {
                    stopTimer();
                    setWarmupDoneShown(true);
                } else {
                    qattempts.current = 0;
                    await getQuestion();
                }
                done();
            });
        } else {
            let message;
            if (selectedAns == currectAns) {
                correctExample.current = true;
                message = phrases?.["15145"];
                if (test.lastPage) {
                    navigate("", {
                        state: {
                            ...location.state,
                            samplesCompleted: true,
                        },
                    });
                }
            } else {
                switch (qattempts.current) {
                    case 0:
                        message = phrases?.["15146"];
                        qattempts.current = qattempts.current + 1;
                        break;
                    case 1:
                        message = phrases?.["15147"];
                        qattempts.current = qattempts.current + 1;
                        break;

                    default:
                        message =
                            phrases?.["15148"] +
                            "<br>" +
                            currectAnsVal +
                            phrases?.["15149"];
                        message = String(message);
                        qattempts.current = qattempts.current + 1;
                        break;
                }
            }
            message = message.split("\\n").join("<br />");
            message =
                `<span style="font-size: medium;vertical-align: text-top;padding-right: 5px;" class="material-icons ${correctExample.current ? "icon-success" : "icon-error"
                }">${correctExample.current ? "check_circle" : "info"}</span>` +
                message;

            setQpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: phrases?.["10980"],
                    popupBody: message,
                    popupFooter: phrases?.["10928"],
                };
                return prev;
            });
        }
    };

    const validateAnswMulti = async (
        selectedAns1,
        selectedAns2,
        selectedAns3,
        selectedAns4,
        question
    ) => {
        let currectAns1, currectAns2, currectAns3, currectAns4;
        let currectAnsVal1, currectAnsVal2, currectAnsVal3, currectAnsVal4;
        for (let i = 0; i < question.questions[0].answers.length; i++) {
            if (question.questions[0].answers[i].score == 1) {
                currectAns1 = i;
                currectAnsVal1 = question.questions[0].answers[i].content;
            }
        }
        for (let i = 0; i < question.questions[1].answers.length; i++) {
            if (question.questions[1].answers[i].score == 1) {
                currectAns2 = i;
                currectAnsVal2 = question.questions[1].answers[i].content;
            }
        }
        for (let i = 0; i < question.questions[2].answers.length; i++) {
            if (question.questions[2].answers[i].score == 1) {
                currectAns3 = i;
                currectAnsVal3 = question.questions[2].answers[i].content;
            }
        }
        for (let i = 0; i < question.questions[3].answers.length; i++) {
            if (question.questions[3].answers[i].score == 1) {
                currectAns4 = i;
                currectAnsVal4 = question.questions[3].answers[i].content;
            }
        }

        if (correctExample.current) {
            startTransition(async () => {
                correctExample.current = false;
                if (test.lastPage) {
                    stopTimer();
                    setWarmupDoneShown(true);
                } else {
                    qattempts.current = 0;
                    await getQuestion();
                }
                done();
            });
        } else {
            let message;
            if (
                selectedAns1 == currectAns1 &&
                selectedAns2 == currectAns2 &&
                selectedAns3 == currectAns3 &&
                selectedAns4 == currectAns4
            ) {
                correctExample.current = true;
                message = phrases?.["15145"];
                if (test.lastPage) {
                    navigate("", {
                        state: {
                            ...location.state,
                            samplesCompleted: true,
                        },
                    });
                }
            } else {
                switch (qattempts.current) {
                    case 0:
                        message = phrases?.["15146"];
                        qattempts.current = qattempts.current + 1;
                        break;
                    case 1:
                        message = phrases?.["15147"];
                        qattempts.current = qattempts.current + 1;
                        break;

                    default:
                        message =
                            phrases?.["15148"] +
                            "<br>" +
                            currectAnsVal1 +
                            "<br >" +
                            currectAnsVal2 +
                            "<br >" +
                            currectAnsVal3 +
                            "<br >" +
                            currectAnsVal4 +
                            "<br >" +
                            phrases?.["15149"];
                        message = String(message);
                        qattempts.current = qattempts.current + 1;
                        break;
                }
            }
            message = message.split("\\n").join("<br />");
            message =
                `<span style="font-size: medium;vertical-align: text-top;padding-right: 5px;" class="material-icons ${correctExample.current ? "icon-success" : "icon-error"
                }">${correctExample.current ? "check_circle" : "info"}</span>` +
                message;
            setQpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: phrases?.["10980"],
                    popupBody: message,
                    popupFooter: phrases?.["10928"],
                };
                return prev;
            });
        }
    };

    const getQuestion = async (warmUpChange = false) => {
        setselectedC((prev) => !prev);
        setnextDisable(true);
        if (location.state.warmUp && !warmUpChange) {
            setTest(exampleTest.current[quesNo.current]);
            if (
                exampleTest.current[quesNo.current].startNumber !==
                exampleTest.current[quesNo.current].endNumber
            ) {
                setSelectedAns1(
                    exampleTest.current[quesNo.current].questions[0]?.userAnswer
                        ?.value !== -1
                        ? exampleTest.current[quesNo.current].questions[0]
                            ?.userAnswer?.value
                        : -1
                );
                setSelectedAns2(
                    exampleTest.current[quesNo.current].questions[1]?.userAnswer
                        ?.value !== -1
                        ? exampleTest.current[quesNo.current].questions[1]
                            ?.userAnswer?.value
                        : -1
                );
                setSelectedAns3(
                    exampleTest.current[quesNo.current].questions[2]?.userAnswer
                        ?.value !== -1
                        ? exampleTest.current[quesNo.current].questions[2]
                            ?.userAnswer?.value
                        : -1
                );
                setSelectedAns4(
                    exampleTest.current[quesNo.current].questions[3]?.userAnswer
                        ?.value !== -1
                        ? exampleTest.current[quesNo.current].questions[3]
                            ?.userAnswer?.value
                        : -1
                );
                if (location.state.test.displayType === "4") {
                    if (
                        exampleTest.current[quesNo.current].questions[0]
                            ?.userAnswer?.value > -1 &&
                        exampleTest.current[quesNo.current].questions[1]
                            ?.userAnswer?.value > -1 &&
                        exampleTest.current[quesNo.current].questions[2]
                            ?.userAnswer?.value > -1 &&
                        exampleTest.current[quesNo.current].questions[3]
                            ?.userAnswer?.value > -1
                    ) {
                        setnextDisable(false);
                    }
                } else {
                    if (
                        exampleTest.current[quesNo.current].questions[0]
                            ?.userAnswer?.value > -1 ||
                        exampleTest.current[quesNo.current].questions[1]
                            ?.userAnswer?.value > -1 ||
                        exampleTest.current[quesNo.current].questions[2]
                            ?.userAnswer?.value > -1 ||
                        exampleTest.current[quesNo.current].questions[3]
                            ?.userAnswer?.value > -1
                    ) {
                        setnextDisable(false);
                    }
                }
            } else {
                if (
                    exampleTest.current[quesNo.current].questions[0]
                        ?.userAnswer !== null
                ) {
                    setSelectedAns(
                        exampleTest.current[quesNo.current].questions[0]
                            ?.userAnswer?.value
                    );
                    setnextDisable(false);
                } else {
                    setSelectedAns(-1);
                }
            }

            let key;
            keyMappings.current = {};
            exampleTest.current[quesNo.current].questions[0].answers.map(
                (val) => {
                    key = `Digit${val.position + 1}`;
                    keyMappings.current = {
                        ...keyMappings.current,
                        [key]: val.position,
                    };
                }
            );
            quesNo.current += 1;
        } else {
            try {
                const response = await getNoCacheCall(
                    TEST_QUESTIONS +
                    location.state.test.id +
                    "/" +
                    quesNo.current,
                    header.current
                );
                setTest(response.data[0]);

                if (
                    location.state.test.displayType === "4" ||
                    location.state.test.displayType === "3"
                ) {
                    if (quesNo.current == -1) {
                        quesNo.current =
                            parseInt(response.data[0].startNumber / 4) + 1;
                    }
                } else {
                    quesNo.current = response.data[0].startNumber;
                }
                let key;
                keyMappings.current = {};
                response.data[0].questions[0].answers.map((val) => {
                    key = `Digit${val.position + 1}`;
                    keyMappings.current = {
                        ...keyMappings.current,
                        [key]: val.position,
                    };
                });
                let dcTime = atob(response.data[0].questions[0].encTmLmt);
                let dcTimeFi = dcTime.split(":");

                if (
                    location.state.test.timeByQuestion &&
                    location.state.test.bShowTimer
                ) {
                    startTimer(parseInt(dcTimeFi[1], 10), "timeByQuestion");
                } else if (
                    location.state.test.bShowTimer &&
                    location.state.test.timeLimit &&
                    !assessmentTimerStarted.current
                ) {
                    const timeLimit = atob(location.state.test.encTmLmt).split(
                        ":"
                    )[1];
                    assessmentTimerStarted.current = timeLimit;
                    startTimer(timeLimit - location.state.test.duration);
                } else {
                    startTimer();
                }
            } catch (error) {
                console.log();
            }
        }
    };

    const exitTest = () => {
        if (location.state.warmUp) {
            navigate("/instructions", {
                state: { ...location.state, warmUp: false },
            });
        } else {
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
        }
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
        stopTimer();
        navigate("/");
    };

    const qclosePopUp = () => {
        setQpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const qapproveAction = () => {
        setQpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const setExampleAns = (selectedAns, multi = false) => {
        if (location.state.warmUp && quesNo.current !== -1) {
            let quesObj =
                location.state.test.testExample[quesNo.current - 1]?.questions;
            if (!multi) {
                const ansObj = {
                    answers: [],
                    structure: null,
                    value: selectedAns,
                };
                quesObj[0].userAnswer = ansObj;
            } else {
                const ansObj1 = {
                    answers: [],
                    structure: null,
                    value: selectedAns1,
                };
                const ansObj2 = {
                    answers: [],
                    structure: null,
                    value: selectedAns2,
                };
                const ansObj3 = {
                    answers: [],
                    structure: null,
                    value: selectedAns3,
                };
                const ansObj4 = {
                    answers: [],
                    structure: null,
                    value: selectedAns4,
                };

                quesObj[0].userAnswer = ansObj1;
                quesObj[1].userAnswer = ansObj2;
                quesObj[2].userAnswer = ansObj3;
                quesObj[3].userAnswer = ansObj4;
            }
        }
    };

    const changeSelectedAns = (e) => {
        setSelectedAns(e.target.value);
        setExampleAns(e.target.value);
        setnextDisable(false);
    };

    const approveAction = async () => {
        stopTimer();
        test.lastPage = true;
        nextNavigate();
    };

    useEffect(() => {
        attachKeyListenRef.current?.focus({
            preventScroll: true,
        });
    }, [test]);

    const detectKeyDown = (e) => {
        e.preventDefault();
        if (
            !loading &&
            location.state.test.displayType !== "2" &&
            location.state.test.displayType !== "3" &&
            location.state.test.displayType !== "4" &&
            !qpopupData?.isOpen
        ) {
            if (e.code in keyMappings.current) {
                setSelectedAns(keyMappings.current[e.code]);
                setExampleAns(keyMappings.current[e.code]);
                setnextDisable(false);
            }
            if (selectedAns !== -1 && e.code === "Space") {
                nextNavigate();
            }
        } else if (qpopupData?.isOpen && e.code === "Space") {
            qapproveAction();
        }
    };

    useEffect(() => {
        if (totalSecLeft === 0) {
            if (
                location.state.test.timeByQuestion &&
                location.state.test.bShowTimer
            ) {
                nextNavigate();
            } else if (
                location.state.test.bShowTimer &&
                location.state.test.timeLimit &&
                assessmentTimerStarted.current
            ) {
                setSessionStatus(true);
            }
        }
        if (assessmentTimerStarted.current) {
            stepRef.current.children[1].children[0].setAttribute(
                "data-secLeft",
                `${min}:${sec}`
            );
        }
    }, [totalSecLeft]);

    useEffect(() => {
        setExampleAns(-1, true);
    }, [selectedAns1, selectedAns2, selectedAns3, selectedAns4]);

    useEffect(() => {
        if (location.state.warmUp) {
            exampleTest.current = location.state.test.testExample;
            quesNo.current = 0;
        }
        getQuestion();
    }, []);

    const sessionApproveAction = async () => {
        setSessionStatus(false);
        stopTimer();
        test.lastPage = true;
        nextNavigate();
    };

    if (!test) {
        return <CommonLoader />;
    }

    const handleMainTestStart = () => {
        if (
            location.state.test.displayType === "4" ||
            location.state.test.displayType === "3"
        ) {
            quesNo.current = -1;
            setSelectedAns1(-1);
            setSelectedAns2(-1);
            setSelectedAns3(-1);
            setSelectedAns4(-1);
            navigate("", {
                state: {
                    ...location.state,
                    warmUp: false,
                    samplesCompleted: true,
                },
            });
            getQuestion(true);
        } else {
            quesNo.current = -1;
            navigate("", {
                state: {
                    ...location.state,
                    warmUp: false,
                    samplesCompleted: true,
                },
            });
            setSelectedAns(-1);
            getQuestion(true);
        }
    };

    if (isWarmupDoneShown) {
        return (
            <WarmupComplete
                backtoInst={exitTest}
                handleMainTestStart={handleMainTestStart}
            />
        );
    }

    return (
        <>
            <div
                className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
                ref={attachKeyListenRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                onBlur={(e) =>
                    e.target.focus({
                        preventScroll: true,
                    })
                }
                style={{ outline: "none" }}
            >
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <div
                    ref={stepRef}
                    className="top-progress-container flex_row sticky full-width g3 bg01"
                >
                    <CommonQuesProgress test={test} />
                    {!location.state.warmUp &&
                        location.state.test.bShowTimer &&
                        location.state.test.timeLimit ? (
                        <ProgressBar
                            circular
                            step={totalSecLeft}
                            steps={assessmentTimerStarted.current}
                            circularColorClass={
                                timerOverallAssessment !== undefined &&
                                    totalSecLeft <= timerOverallAssessment
                                    ? "progress-bar-color"
                                    : ""
                            }
                        />
                    ) : (
                        <></>
                    )}
                </div>

                <div className="flex_col g2">
                    <h3>
                        {location.state.warmUp
                            ? location.state.test.testExampleName
                            : location.state.test.name}
                    </h3>
                    <div
                        className="base questionText"
                        dangerouslySetInnerHTML={{
                            __html: test.questions[0].topicInstruction,
                        }}
                    />
                </div>
                <form
                    ref={formRef}
                    className={
                        location.state.test.displayType === "3"
                            ? "flex_col position_relative g2"
                            : "flex_row flex_col_tablet position_relative g2"
                    }
                >
                    <QuesLoader show={phase === "showing-loader"} />
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="small-title">{phrases?.["13106"]}</div>
                        <div
                            className={`p4 roundness_1 border_tt82 full-height flex_col g2 align-items_center justify-content_center base`}
                        >
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.questionText && (
                                            <div
                                                key={val.id}
                                                className="questionText"
                                                dangerouslySetInnerHTML={{
                                                    __html: val.questionText,
                                                }}
                                            />
                                        )
                                )}
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.questionImage && (
                                            <img
                                                key={val.id}
                                                src={buildMediaUrl(
                                                    val.questionImage
                                                )}
                                                alt="question-image"
                                            />
                                        )
                                )}
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.media &&
                                        val.media.map((media, ind) => (
                                            <img
                                                key={media.id}
                                                src={buildMediaUrl(media.url)}
                                                alt="question-image"
                                            />
                                        ))
                                )}
                            {location.state.test.displayType === "3" && (
                                <img
                                    src={buildMediaUrl(
                                        test.questions[0].questionImage
                                    )}
                                    alt="question-image"
                                />
                            )}
                        </div>
                    </div>
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="flex_row justify-content_between">
                            <div className="small-title">
                                {phrases?.["15138"]}
                            </div>
                            {!location.state.warmUp &&
                                location.state.test.timeByQuestion &&
                                location.state.test.bShowTimer && (
                                    <ul className="list-icon m0 p0 base">
                                        <li>
                                            <span className="material-icons-outlined icon-order">
                                                timer
                                            </span>
                                            {min}:{sec}
                                        </li>
                                    </ul>
                                )}
                        </div>
                        <div className="p4 roundness_1 border_tt82 full-height">
                            <div className="flex_col g2 base">
                                {location.state.test.displayType === "4" && (
                                    <DisplayType4
                                        test={test}
                                        setnextDisable={setnextDisable}
                                        setSelectedAns1={setSelectedAns1}
                                        setSelectedAns2={setSelectedAns2}
                                        setSelectedAns3={setSelectedAns3}
                                        setSelectedAns4={setSelectedAns4}
                                        selectedAns1={selectedAns1}
                                        selectedAns2={selectedAns2}
                                        selectedAns3={selectedAns3}
                                        selectedAns4={selectedAns4}
                                        selectedC={selectedC}
                                    />
                                )}
                                {location.state.test.displayType === "2" && (
                                    <DisplayType2
                                        test={test}
                                        setnextDisable={setnextDisable}
                                        phrases={phrases}
                                        selectedAns={selectedAns}
                                        setSelectedAns={setSelectedAns}
                                        selectedC={selectedC}
                                        setExampleAns={setExampleAns}
                                    />
                                )}
                                {location.state.test.displayType === "3" && (
                                    <DisplayType3
                                        test={test}
                                        phrases={phrases}
                                        setnextDisable={setnextDisable}
                                        setSelectedAns1={setSelectedAns1}
                                        setSelectedAns2={setSelectedAns2}
                                        setSelectedAns3={setSelectedAns3}
                                        setSelectedAns4={setSelectedAns4}
                                        selectedAns1={selectedAns1}
                                        selectedAns2={selectedAns2}
                                        selectedAns3={selectedAns3}
                                        selectedAns4={selectedAns4}
                                        selectedC={selectedC}
                                    />
                                )}
                                {(location.state.test.displayType === "1" ||
                                    location.state.test.displayType ===
                                    "6") && (
                                        <fieldset
                                            aria-label="group-container"
                                            className="radio-group-container"
                                        >
                                            {test.questions[0].answers.map(
                                                (val, ind) => (
                                                    <div
                                                        key={test.startNumber + ind}
                                                        className="radio-container"
                                                    >
                                                        <input
                                                            id={`option-${ind}`}
                                                            type="radio"
                                                            name="tt82_options"
                                                            value={val.position}
                                                            onChange={
                                                                changeSelectedAns
                                                            }
                                                            checked={
                                                                selectedAns ==
                                                                val.position
                                                            }
                                                        />
                                                        <label
                                                            dangerouslySetInnerHTML={{
                                                                __html: val.content,
                                                            }}
                                                            htmlFor={`option-${ind}`}
                                                        />
                                                    </div>
                                                )
                                            )}
                                        </fieldset>
                                    )}
                            </div>
                        </div>
                    </div>
                </form>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage ? (
                        location.state.warmUp ? (
                            <button
                                className="button-secondary text_uppercase text_uppercase full-width_mobile"
                                onClick={exitTest}
                                disabled={loading}
                            >
                                {phrases?.["1000229"]}
                            </button>
                        ) : (
                            <div />
                        )
                    ) : (
                        <button
                            className="text_uppercase button-secondary full-width_mobile"
                            onClick={exitTest}
                            disabled={loading}
                        >
                            {location.state.warmUp
                                ? phrases?.["1000229"]
                                : phrases?.["1002190"]}
                        </button>
                    )}
                    <button
                        className="button-primary text_uppercase full-width_mobile"
                        onClick={nextNavigate}
                        disabled={nextDisable || loading}
                    >
                        {test.lastPage
                            ? location.state.warmUp
                                ? correctExample.current
                                    ? phrases?.["1000252"]
                                    : phrases?.["10976"]
                                : phrases?.["15140"]
                            : phrases?.["10976"]}
                        <span className="material-icons right">
                            arrow_forward
                        </span>
                    </button>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
            <QuestionCommonPopup
                popupData={qpopupData}
                closeAction={qclosePopUp}
                approveAction={qapproveAction}
            />
            <SessionExpireCommonPopup
                sessionStatus={sessionStatus}
                sessionApproveAction={sessionApproveAction}
            />
        </>
    );
};

export default TestTaker21;
